import { Box, Stack, Tooltip, Typography } from '@mui/material';
import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { useGlobalStore } from '@old/global-store/use-store';
import { PATH } from '@siloreal:app:config';
import ASSETS from '@siloreal:modules:private/silobag-list/config/extra/assets';
import { ColDef, SilobagRow } from '@siloreal:modules:private/silobag-list/config/extra/types';
import * as HOOKS from '@siloreal:shared:hooks';

export function buildInconsistenciesColumn(): ColDef {
  return {
    field: 'inconsistencies',
    headerName: HOOKS.useLocale.getState().t('temp.common.inconsistencies'),
    width: 78,
    sortable: false,
    renderCell: (params) => {
      const count = params.row.disc_discrepancies_results.length;
      if (!count) return null;

      return <InconsistenciesCell row={params.row} count={count} />;
    },
  };
}

function InconsistenciesCell({ row, count }: { row: SilobagRow; count: number }) {
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();

    const { filtersInconsistencies, setFiltersInconsistencies } = useGlobalStore.getState();
    setFiltersInconsistencies({
      ...filtersInconsistencies,
      silobagId: String(row.id),
    });
    navigate(PATH.INCONSISTENCIES, { state: { filteredId: true } });
  };

  const i18n = HOOKS.useLocale();
  const VIEW_INCONSISTENCIES_TOOLTIP = i18n.t('temp.private.list.silospro.view_inconsistencies');

  return (
    <Tooltip title={VIEW_INCONSISTENCIES_TOOLTIP} placement="top" arrow>
      <Stack
        component="button"
        type="button"
        height="100%"
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1.5}
        onClick={handleClick}
        aria-label={VIEW_INCONSISTENCIES_TOOLTIP}
        sx={{
          p: 0,
          m: 0,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          '&:hover .inconsistencies-icon': {
            backgroundColor: '#FFC2C8',
          },
        }}
      >
        <Box
          className="inconsistencies-icon"
          sx={{
            width: 28,
            height: 28,
            borderRadius: 2,
            backgroundColor: '#FFD4D8',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {ASSETS.INCONSISTENCIES}
        </Box>
        <Typography fontSize={14} fontWeight={600} sx={{ color: '#FF1414' }} lineHeight={1.55}>
          {count}
        </Typography>
      </Stack>
    </Tooltip>
  );
}
